<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <form [formGroup]="clientForm">
      <h1
        class="mb-3 d-flex justify-content-between align-items-center"
        *ngIf="headingStatus">
        {{ createNewContact }}
      </h1>
      <h1 class="mb-3" *ngIf="!headingStatus">{{ updateNewContact }}</h1>
      <div class="row">
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="firstName">First Name</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="firstname"
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
              [ngClass]="{ 'has-error': formErrors['firstName'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['firstName']">
              {{ formErrors["firstName"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="lastName">Last Name</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="lastname"
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
              [ngClass]="{ 'has-error': formErrors['lastName'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['lastName']">
              {{ formErrors["lastName"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="phoneNumber">Phone Number</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              jni-phone-number-formatting
              name="phone"
              type="text"
              class="form-control"
              id="phoneNumber"
              placeholder=""
              formControlName="phoneNumber"
              [ngClass]="{ 'has-error': formErrors['phoneNumber'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['phoneNumber']">
              {{ formErrors["phoneNumber"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="email">Email Address</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="email"
              type="text"
              class="form-control"
              id="email"
              placeholder=""
              formControlName="email"
              [ngClass]="{ 'has-error': formErrors['email'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['email']">
              {{ formErrors["email"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="contactType">Type</label>
            <p-select
              id="contactType"
              formControlName="type"
              [options]="type"
              optionLabel="name"
              optionValue="name"
              [disabled]="isFromOrdersAddNewBuyer"
              placeholder="Select a contact type">
            </p-select>
          </div>
        </div>
        <div class="col-12 mb-2" [hidden]="true">
          <div class="has-float-label">
            <label class="form-label" for="title">title</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="title"
              type="text"
              class="form-control"
              id="title"
              placeholder=""
              formControlName="title" />
          </div>
        </div>
        <div class="col-12 mb-4" [hidden]="true">
          <div class="has-float-label">
            <input
              jniAutoCompleteBlocker
              name="electronicAddressIdD365"
              type="text"
              class="form-control"
              id="electronicAddressIdD365"
              placeholder=""
              formControlName="electronicAddressIdD365" />
            <label class="form-label" for="electronicAddressIdD365"
              >electronicAddressIdD365</label
            >
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="switcher">
            <label class="form-label" for="rcCheck">Primary</label>
            <div class="d-flex align-items-center form-switch">
              <!-- Commented for now  -->
              <!-- <label class="form-check-label" for="rcCheck">{{
                this.clientForm.get("isPrimary")?.value
              }}</label> -->
              <p-toggleswitch
                name="rcCheck"
                class="form-check-input me-2"
                type="checkbox"
                id="rcCheck"
                formControlName="isPrimary" />
            </div>
          </div>
        </div>
      </div>
      <!-- <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!clientForm.valid"
        (click)="onSubmit()">
        Save
      </button> -->
      <p-button
        label="Save"
        type="submit"
        (click)="onSubmit()"
        class="me-3 post" />
    </form>
  </div>
</p-drawer>
